import styled from 'styled-components';

import {
  borderColor,
  dangerHighlightColor,
  dangerTextColor,
  sectionColor,
  warnHighlightColor,
  warnTextColor
} from '../../../lib/theme';

export const PreviewContainer = styled.div`
  border: 1px solid ${borderColor};
  border-radius: 4px;
  background: ${sectionColor};
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PreviewSurface = styled.div`
  background: #fff;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  overflow: hidden;
`;

export const SurfaceHeader = styled.div`
  padding: 8px 12px;
  border-bottom: 1px solid ${borderColor};
`;

export const EmailSubject = styled.div`
  padding: 8px 12px;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid ${borderColor};
  word-break: break-word;
`;

// Empty sandbox is the security boundary — fixed, scrolling viewport so a long
// email scrolls inside the frame rather than growing the compose panel.
export const EmailFrame = styled.iframe`
  display: block;
  width: 100%;
  height: 50vh;
  border: none;
`;

export const SmsBody = styled.div`
  padding: 12px;
`;

export const SmsBubble = styled.div`
  display: inline-block;
  max-width: 85%;
  background: ${sectionColor};
  border-radius: 16px;
  padding: 10px 14px;
  font-size: 14px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
`;

// Mirrors the injected email-doc mark colours so an unresolved token highlights
// identically in both surfaces — data-issue attribute selectors, no tokenizer.
export const SmsMark = styled.mark`
  border-radius: 2px;
  padding: 0 2px;

  &[data-issue='unknown'] { background: ${dangerHighlightColor}; color: ${dangerTextColor}; }
  &[data-issue='missing-fallback'] { background: ${warnHighlightColor}; color: ${warnTextColor}; }
`;

export const PreviewPlaceholder = styled.div`
  padding: 24px 12px;
  text-align: center;
`;
